<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>

          <!-- Dialog export / import -->
          <v-col cols="12">
            <v-btn color="primary" depressed @click="dialogAdd = true, validate('ADD')">
              <v-icon left>mdi-text-box-plus</v-icon>
              Add
            </v-btn>
            <v-btn color="yellow-light" @click="exportData()">
              <v-icon left>mdi-download</v-icon>
              Export Data
            </v-btn>
          </v-col>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">เพิ่มข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form
                    ref="form_add"
                    v-model="valid_add"
                    lazy-validation
                  >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="ชื่อประเภทการลา*"
                        v-model="formAdd.quotaLeaveName"
                        :rules="nameRules"
                        outlined
                        :counter="30"
                        maxlength="30"
                        required
                      ></v-text-field>
                    </v-col>
                      <v-col cols="4">
                      <v-text-field
                        label="จำนวนวันลา /วัน*"
                        v-model="formAdd.quotaLeave"
                        outlined
                        :rules="QuotaRules"
                        :counter="2"
                        maxlength="2"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="ลาล่วงหน้าอย่างน้อย /วัน*"
                        v-model="formAdd.leaveConditionAfterDay"
                        @keyup="checkLeaveAfterDay()"
                        :rules="QuotaRules"
                        outlined
                        :counter="2"
                        maxlength="2"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-select
                        v-model="formAdd.positionTypeCode"
                        :items="PositionLevelItem"
                        dense
                        outlined
                        hide-details
                        label="ระดับพนักงาน"
                        class="ma-2"
                    ></v-select>
                    </v-col>
                    <v-col cols="4">
                     <v-switch
                      v-model="formAdd.leaveOptioneAttached"
                      label="ลาประเภทนี้ต้องแนบไฟล์"
                    ></v-switch>
                    </v-col>
                    <v-col cols="6">
                     <v-switch
                      v-model="formAdd.leaveOptionBack"
                      @change="checkLeaveBlack"
                      label="ลาประเภทนี้ลาย้อนหลัง (กรณีลาย้อนหลัง วันลาล่วงหน้าเป็น 0)"
                    ></v-switch>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="formAdd.leaveCondition"
                        maxlength="100"
                        rows="3"
                        row-height="25"
                        outlined
                        :rules="conditionlRules"
                        clearable
                        clear-icon="mdi-close-circle"
                        label="เงื่อนไขการลา"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="dialogAdd = false,clearData()"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  :disabled="!valid_add"
                  @click="addData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">แก้ไขข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                   <v-form
                    ref="form_update"
                    v-model="valid_update"
                    lazy-validation
                  >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัสประเภทการลา*"
                        v-model="formUpdate.quotaLeaveCode"
                        outlined
                        :counter="30"
                        maxlength="30"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="ชื่อประเภทการลา*"
                        v-model="formUpdate.quotaLeaveName"
                        outlined
                        :rules="nameRules"
                        :counter="30"
                        maxlength="30"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="จำนวนวันลา /วัน*"
                        v-model="formUpdate.quotaLeave"
                        outlined
                        :rules="QuotaRules"
                        :counter="2"
                        maxlength="2"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="ลาล่วงหน้าอย่างน้อย /วัน*"
                        v-model="formUpdate.leaveConditionAfterDay"
                        @keyup="checkLeaveAfterDay()"
                        :rules="QuotaRules"
                        outlined
                        :counter="2"
                        maxlength="2"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-select
                        v-model="formUpdate.positionTypeName"
                        :items="PositionLevelItem"
                        dense
                        outlined
                        hide-details
                        label="ระดับพนักงาน"
                        class="ma-2"
                    ></v-select>
                    </v-col>
                    <v-col cols="4">
                     <v-switch
                      v-model="formUpdate.leaveOptioneAttached"
                      label="ลาประเภทนี้ต้องแนบไฟล์"
                    ></v-switch>
                    </v-col>
                    <v-col cols="6">
                     <v-switch
                      v-model="formUpdate.leaveOptionBack"
                       @change="checkLeaveBlack"
                      label="ลาประเภทนี้ลาย้อนหลัง (กรณีลาย้อนหลัง วันลาล่วงหน้าเป็น 0)"
                    ></v-switch>
                    </v-col>
                      <v-col cols="12">
                      <v-textarea
                        v-model="formUpdate.leaveCondition"
                        maxlength="100"
                        rows="3"
                        row-height="25"
                        outlined
                        :rules="conditionlRules"
                        clearable
                        clear-icon="mdi-close-circle"
                        label="เงื่อนไขการลา"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                   </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="blue darken-1"
                  text
                  @click="dialogEdit = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  :disabled="!valid_update"
                  @click="editData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  แก้ไข
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัสประเภทการลา*"
                        v-model="formUpdate.quotaLeaveCode"
                        :counter="30"
                        maxlength="30"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="ชื่อประเภทการลา*"
                        v-model="formUpdate.quotaLeaveName"
                        :rules="nameRules"
                        outlined
                        :counter="30"
                        maxlength="30"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        label="จำนวนวันลา*"
                        v-model="formUpdate.quotaLeave"
                        :rules="QuotaRules"
                        outlined
                        :counter="2"
                        maxlength="2"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        label="ลาล่วงหน้าอย่างน้อย*"
                        v-model="formUpdate.leaveConditionAfterDay"
                        :rules="QuotaRules"
                        outlined
                        :counter="2"
                        maxlength="2"
                        required
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        v-model="formUpdate.positionTypeName"
                        :items="PositionLevelItem"
                        dense
                        outlined
                        hide-details
                        label="ระดับพนักงาน"
                        class="ma-2"
                        readonly
                    ></v-select>
                    </v-col>
                     <v-col cols="4">
                     <v-switch
                      v-model="formUpdate.leaveOptioneAttached"
                      label="ลาประเภทนี้ต้องแนบไฟล์"
                      readonly
                      disabled
                    ></v-switch>
                    </v-col>
                      <v-col cols="6">
                     <v-switch
                      v-model="formUpdate.leaveOptionBack"
                      label="ลาประเภทนี้ลาย้อนหลัง (กรณีลาย้อนหลัง วันลาล่วงหน้าเป็น 0)"
                      readonly
                      disabled
                    ></v-switch>
                    </v-col>
                      <v-col cols="12">
                      <v-textarea
                        v-model="formUpdate.leaveCondition"
                        maxlength="100"
                        rows="3"
                        row-height="25"
                        outlined
                        :rules="conditionlRules"
                        clearable
                        clear-icon="mdi-close-circle"
                        label="เงื่อนไขการลา"
                        readonly
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  text
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :items-per-page="10"
                >
                   <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date(item.CREATE_DATE) }}
                  </template>
                   <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_date(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogEdit = true), getDataById(item), validate('UPDATE')"
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>
                    <v-btn
                      color="red"
                      dark
                      fab
                      small
                      @click.stop="(dialogDelete = true), getDataById(item)"
                    >
                      <v-icon> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/leave_quota/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'โควต้าการลา',
          disabled: false,
          href: '/HRM/Leave/Quota'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'LEAQUOTA_', // Generate Code
      valid_add: true,
      valid_update: true,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      formAdd: {
        quotaLeaveCode: '',
        quotaLeaveName: '',
        quotaLeave: '0',
        positionTypeCode: '',
        leaveConditionAfterDay: '0',
        leaveOptioneAttached: false,
        leaveCondition: '-',
        leaveOptionBack: false
      },
      formUpdate: {
        quotaLeaveCode: '',
        quotaLeaveName: '',
        quotaLeave: '0',
        positionTypeName: '',
        leaveConditionAfterDay: '0',
        leaveOptioneAttached: false,
        leaveCondition: '-',
        leaveOptionBack: false
      },
      formUpdateItem: {
        quotaLeaveCode: '',
        quotaLeaveName: '',
        quotaLeave: '0',
        positionTypeName: '',
        leaveConditionAfterDay: '0',
        leaveOptioneAttached: false,
        leaveCondition: '-',
        leaveOptionBack: false
      },
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 30 || 'Name must be less than 30 characters'
      ],
      conditionlRules: [
        (v) => !!v || 'Leave Condition is required'
      ],
      QuotaRules: [
        (v) => !!v || 'Quota is required',
        (v) => (!isNaN(parseFloat(v)) && v >= 0 && v <= 99) || 'Qupta has to be between 0 and 99'
      ],
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รหัสประเภทการลา', value: 'quotaLeaveCode' },
        { text: 'ชื่อประเภทการลา', value: 'quotaLeaveName' },
        { text: 'จำนวนวันลา  /วัน', value: 'quotaLeave' },
        { text: 'ลาล่วงหน้า /วัน', value: 'leaveConditionAfterDay' },
        { text: 'ระดับการลา', value: 'positionTypeName' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' }
        // { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      PositionLevelItem: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'quotaLeaveID', value: 'quotaLeaveID' },
        { text: 'quotaLeaveCode', value: 'quotaLeaveCode' },
        { text: 'quotaLeaveName', value: 'quotaLeaveName' },
        { text: 'quotaLeave', value: 'quotaLeave' },
        { text: 'positionTypeName', value: 'positionTypeName' },
        { text: 'leaveConditionAfterDay', value: 'leaveConditionAfterDay' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ]
      // End Export Config
    }
  },
  async mounted () {
    this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataPositionLevel()
    await this.getData()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getData () {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      this.getDataByIdGlobal(this.DNS_IP, this.path, 'quotaLeaveID', item.quotaLeaveID)
    },

    async addData () {
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = this.$session.getAll().data.userName
      this.formAdd.LAST_USER = this.$session.getAll().data.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.quotaLeaveCode = this.code + this.generateCodeGlobal()
      //
      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //

      console.log('form', JSON.stringify(this.formAdd))

      this.dataReady = false
      this.addDataGlobal(this.DNS_IP, this.path, this.formAdd)
    },
    async editData () {
      // Config User ทำรายการล่าสุด
      this.formUpdateItem.LAST_USER = this.$session.getAll().data.userName
      // End Config User ทำรายการล่าสุด

      for (var key in this.formUpdateItem) {
        for (var key2 in this.formUpdate) {
          if (key === key2) {
            this.formUpdateItem[key] = this.formUpdate[key2]
          }
        }
      }
      console.log('this.formUpdateItem', this.formUpdateItem)

      // Debug
      console.log('EDIT PK : ', this.PK)
      console.log('formUpdateItem', JSON.stringify(this.formUpdateItem))
      // End Debug
      // สำหรับ แก้ไขข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนแก้ไขล่าสุด
      //
      this.dataReady = false
      this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
    },
    async deleteData () {
      console.log('DELETE PK : ', this.PK)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(this.DNS_IP, this.path, this.PK)
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }

      // eslint-disable-next-line no-redeclare
      // for (var key in this.search) {
      //   if (this.search[key]) {
      //     this.search[key] = ''
      //   }
      // }
    },
    async checkLeaveBlack () {
      console.log('check levae back')
      this.formAdd.leaveConditionAfterDay = (this.formAdd.leaveOptionBack) ? '0' : this.formAdd.leaveConditionAfterDay
      this.formUpdate.leaveConditionAfterDay = (this.formUpdate.leaveOptionBack) ? '0' : this.formUpdate.leaveConditionAfterDay
    },
    async checkLeaveAfterDay () {
      console.log(this.formAdd.leaveConditionAfterDay)
      this.formAdd.leaveOptionBack = (this.formAdd.leaveConditionAfterDay !== '0') ? false : this.formAdd.leaveOptionBack
      this.formUpdate.leaveOptionBack = (this.formUpdate.leaveConditionAfterDay !== '0') ? false : this.formUpdate.leaveOptionBack
    },
    exportData () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_quota/' + "get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            var s = {}
            s.quotaLeaveCode = element.quotaLeaveCode
            s.quotaLeaveName = element.quotaLeaveName
            s.quotaLeave = element.quotaLeave
            s.positionTypeName = element.positionTypeName
            tem.push(s)
          })
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          XLSX.writeFile(wb, 'Leave-Quota.xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataPositionLevel () {
      this.PositionLevelItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/pos_position_type/get",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.positionTypeName
            s.value = d.positionTypeCode
            d = s
            this.PositionLevelItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Leave/LeaveQuota.vue